import {
    GET_DATA_MAIN_MENUAUTHORIZATION, SET_DATA_MAIN_MENUAUTHORIZATION,
    GET_DATA_User,SET_DATA_MAIN_PERMISSION
} from '../actions/actionTypes'
import {
    RequertMainMenuAuthorizationFaileAction, GetDataMainMenuAuthorizationSuccessAction,
    RequertUserFaileAction, GetDataUserSuccessAction,RequertPermissionFaileAction,
    IsResultAction
} from '../actions'

import { put, takeLatest } from 'redux-saga/effects'
import { Api } from './api'

function* GetDataMain() {
    try {
        const DataMain = yield Api.GetDataMenuFromApi();
        yield put(GetDataMainMenuAuthorizationSuccessAction(DataMain))
    } catch (error) {
        yield put(RequertMainMenuAuthorizationFaileAction(error))
    }
}
export function* watchGetDataMain() {
    yield takeLatest(GET_DATA_MAIN_MENUAUTHORIZATION, GetDataMain)
}
//getdata user
function* GetDataUser() {
    try {
        const DataUser = yield Api.GetDataUserFromApi();
        yield put(GetDataUserSuccessAction(DataUser))
    } catch (error) {
        yield put(RequertUserFaileAction(error))
    }
}
export function* watchGetDataUser() {
    yield takeLatest(GET_DATA_User, GetDataUser)
}

function* SetDataMain(action) {
    try {
        const isResult = yield Api.SetDataMenuFromApi(action.DataMain);
        if (isResult) {
            yield put(IsResultAction(isResult))
        }
        else {
            yield put(RequertMainMenuAuthorizationFaileAction("error"))
        }
    } catch (error) {
        yield put(RequertMainMenuAuthorizationFaileAction(error))
    }
}

export function* watchSetDataMain() {
    yield takeLatest(SET_DATA_MAIN_MENUAUTHORIZATION, SetDataMain)
}

// set permisstion
function* SetDataPermission(action) {
    try {
        const isResult = yield Api.SetDataPermission(action.DataMain);
        if (isResult) {
            yield put(IsResultAction(isResult))
        }
        else {
            yield put(RequertPermissionFaileAction("error"))
        }
    } catch (error) {
        yield put(RequertPermissionFaileAction(error))
    }
}
export function* watchSetDatapermission() {
    yield takeLatest(SET_DATA_MAIN_PERMISSION, SetDataPermission) 
}